<template>
    <div>
        <el-row type="flex" style="padding: 10px 0px;" justify="end">
			<el-col :span="2" style="text-align: right;" >
			<label style="color: #606266;font-size: 14px;line-height: 32px;width: 100px;">所属实体:</label>
			</el-col>
			<el-col :span="2" style="text-align: right;margin-left:30px" >
				<el-select v-model="manualGroupCompanyName" placeholder="所属实体" style="width: 180px;" @change="companyNameSelectChange">
					<el-option
						v-for="item in manualGroupCompanyData"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</el-col>
            <el-col :span="6"  style="margin-left:50px">
                <el-input v-model="voucherImportSearchName" placeholder="原文档名称、凭证号" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryUploadData"></el-input>
            </el-col>
			<el-col :span="2" style="margin-left:30px;">
                <el-button type="primary" style="width: 140px;" @click="relationVoucherClick">手工关联记账凭证</el-button>
            </el-col>
        </el-row>
        
		<div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-files"></i><span>档案采集</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>未关联记账凭证</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container">
            <div>
                <el-table ref="relationArchivesVoucher" :data="relationArchivesVoucherTableData" border stripe class="table" height="530px" >
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="voucherNo" label="凭证号"></el-table-column>
					<el-table-column prop="voucherAmount" label="凭证金额"></el-table-column>
                    <el-table-column prop="createTime" label="创建时间"></el-table-column>
                    <el-table-column prop="source" label="凭证来源" :formatter="this.formatSource"></el-table-column>
                    <el-table-column prop="fileName" label="原文档名称"></el-table-column>
					<el-table-column prop="operate" label="操作" width="100" fixed="right" align="center">
						<template slot-scope="scoped">
							<el-button size="small" type="text" @click="oriVoucherEditClickFun(scoped.row)">编辑</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="relationStatus" label="失败原因">
						<template slot-scope="scoped">
							{{scoped.row.relationStatus == '1' ?'所关联的记账凭证已成册':'未找到对应记账凭证'}}
						</template>
					</el-table-column>
                </el-table>
                <div class="pagination">
                    <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="voucherpwm.page"
                        :page-size="voucherpwm.limit"
                        :page-sizes="voucherpwm.limits"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="voucherpwm.count">
                    </el-pagination>
                </div>
            </div>
		</div>

		<el-dialog title="关联记账凭证" :visible.sync="viewDialogVisible" width="1000px"   class="dialog" :close-on-click-modal="false">
			<el-tabs v-model="activeName" @tab-click="handleClick" style="margin-top:-25px">
				<el-tab-pane label="未成册数据" name="first">
					<div>
						<el-row type="flex" style="padding: 10px 0px;" justify="end">
							<el-col :span="6"  style="margin-left:100px">
								<el-input v-model="dialogVoucherSearchName" placeholder="批次号、凭证号" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryData"></el-input>
							</el-col>
						</el-row>
						<el-table ref="accountingVoucherUploadTable" :data="accountingVoucherUploadTableData" border stripe class="table" height="530px" @row-click="(row) => clickRowByChecked('accountingVoucherUploadTable', row)" @select="select" @select-all="selectAll">
									<el-table-column type="selection" width="55" align="center"></el-table-column>
									<el-table-column prop="batchNo" label="批次号"></el-table-column>
									<el-table-column prop="amountLocalDb" label="主体金额"></el-table-column>
									<el-table-column prop="voucherNo" label="记账凭证号"></el-table-column>
									<el-table-column prop="year" label="财年"></el-table-column>
									<el-table-column prop="voucherDate" label="凭证时间"></el-table-column>
						</el-table>
						<div class="pagination">
							<el-pagination
								@size-change="dialogHandleSizeChange"
								@current-change="dialogHandleCurrentChange"
								:current-page="dialogVoucherpwm.page"
								:page-size="dialogVoucherpwm.limit"
								:page-sizes="dialogVoucherpwm.limits"
								layout="total, sizes, prev, pager, next, jumper"
								:total="dialogVoucherpwm.count">
							</el-pagination>
						</div>
						<span type="flex" style="padding: 10px 0px;" justify="center">
							<el-button @click="viewDialogVisible=false">取 消</el-button>
							<el-button type="primary" @click="sureRelation">确 定</el-button>
						</span>      
					</div>
				</el-tab-pane>
				<el-tab-pane label="已成册数据" name="second">
					<div>
						<el-row type="flex" style="padding: 10px 0px;" justify="end">
							<el-col :span="6"  style="margin-left:100px">
								<el-input v-model="dialogVoucherSearchName" placeholder="批次号、凭证号" prefix-icon="el-icon-search" clearable @keyup.native="advanceQueryData"></el-input>
							</el-col>
						</el-row>
						<el-table ref="accountingVoucherBookTable" :data="accountingVoucherBookTableData" border stripe class="table" height="530px" @row-click="(row) => clickRowByChecked('accountingVoucherBookTable', row)" @select="select" @select-all="selectAll">
									<el-table-column type="selection" width="55" align="center"></el-table-column>
									<el-table-column prop="batchNo" label="批次号"></el-table-column>
									<el-table-column prop="amountLocalDb" label="主体金额"></el-table-column>
									<el-table-column prop="voucherNo" label="记账凭证号"></el-table-column>
									<el-table-column prop="year" label="财年"></el-table-column>
									<el-table-column prop="voucherDate" label="凭证时间"></el-table-column>
						</el-table>
						<div class="pagination">
							<el-pagination
								@size-change="dialogHandleSizeChange"
								@current-change="dialogHandleCurrentChange"
								:current-page="dialogVoucherpwm.page"
								:page-size="dialogVoucherpwm.limit"
								:page-sizes="dialogVoucherpwm.limits"
								layout="total, sizes, prev, pager, next, jumper"
								:total="dialogVoucherpwm.count">
							</el-pagination>
						</div>
						<span type="flex" style="padding: 10px 0px;" justify="center">
							<el-button @click="viewDialogVisible=false">取 消</el-button>
							<el-button type="primary" @click="bookRelation">确 定</el-button>
						</span>      
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-dialog>


	<el-dialog v-dialogDrag title="原始凭证信息编辑" :visible.sync="oriVoucherEditDialogVisible" width="890px" class="dialog" :close-on-click-modal="false">
			<div class="custom-dialog">
				<el-form :model="oriVoucherEditForm" ref="oriVoucherEditForm" :rules="oriVoucherEditFormRule" style="width: 98%;padding-left: 30px;">
					<el-input v-if="show == true" v-model="oriVoucherEditForm.id" id="hideId"></el-input>
					<div style="display: flex;padding-top: 10px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">*</span> 凭证类型</label>
						</div>
						<div class="voucher-img-div" v-for="(imgObj, index) in voucherTypeImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name  @click="voucherTypeImgClickFun($event, index)">
						</div>
					</div>
					<div style="display: flex;padding-top: 8px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">*</span> 凭证号码</label>
						</div>
						<el-form-item prop="voucherNo">
							<el-input v-model="oriVoucherEditForm.voucherNo" style="width: 300px;"></el-input>
						</el-form-item>
					</div>
					<div style="display: flex;padding-top: 8px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">*</span> 凭证金额</label>
						</div>
						<el-form-item prop="voucherAmount">
							<el-input v-model="oriVoucherEditForm.voucherAmount" type="number" style="width: 300px;"></el-input>
						</el-form-item>
					</div>
					<div style="display: flex;padding-top: 8px;">
						<div style="width: 70px;margin-right: 15px;line-height: 37px;">
							<label style="color: #606266;"><span style="color: red;">&nbsp;</span> 凭证日期</label>
						</div>
						<el-form-item prop="voucherDate">
							<el-date-picker v-model="oriVoucherEditForm.invoiceDate" type="date" placeholder="凭证日期" format="yyyy年MM月dd日" value-format="yyyyMMdd" style="width: 300px;"></el-date-picker>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" style="width: 80px;" @click="saveOriginalVoucherData()">保存</el-button>
				<el-button plain @click="oriVoucherEditDialogVisible = false" style="width: 80px;">返回</el-button>
			</span>
		</el-dialog>
	</div>


</template>

<script>
import https, { fetchPost } from '../../../../https.js';
export default {
    name: 'basetable',
    data() {
        return{
            relationArchivesVoucherTableData: [],
            voucherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100],
				param:{
					
				}
			},
			pwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
            dialogVoucherpwm:{
                count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100],
				param:{
					
				}
            },
            voucherImportSearchName:'',
            dialogVoucherSearchName:'',
            viewDialogVisible: false,
			show: false,
            accountingVoucherUploadTableData: [],
			accountingVoucherBookTableData: [],
			oriVoucherEditForm: {
				id: '',
				voucherNo: '',
				voucherAmount: ''	
			},
			oriVoucherEditFormRule: {
				voucherNo: [
					{ required: true, message: '请输入凭证号码', trigger: 'blur' },
					{ max: 50, message: '凭证号码不得超过50个字符'},
				],
				voucherAmount: [
					{ required: true, message: '请输入凭证金额', trigger: 'blur' },
					// { validator(rule, value, callback) {
					// 	if(value.indexOf('.') != -1) {
					// 		let val = value.substr(value.indexOf('.') + 1);
					// 		if(val.length <= 2) {
					// 			return callback();
					// 		}
					// 		callback(new Error('小数点后最多输入两位'));
					// 	}
					// } }
				]
			},
			//	原始凭证信息编辑
			oriVoucherEditDialogVisible: false,
			formatVoucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),
			voucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),	//	凭证类型
			activeName: 'first',
			manualGroupCompanyName: '', //  所属实体
			manualGroupCompanyData: [],
        }
    },
    created: function() {
		this.getUserCheckCompanyList().then(companyData => {
                if(companyData && companyData.length > 0) {
                   this.manualGroupCompanyName = companyData[0].id;
                }
                this.manualGroupCompanyData = companyData;
            });
        this.getRelationVoucherData();
	},
  	methods: {
        //刷新
        refresh() {
			this.getRelationVoucherData();
		},
		tableRowClassName({row, rowIndex}) {
			row.rowIndex = rowIndex;
		},
        handleSizeChange(val) {
			this.voucherpwm.limit = val;
			this.getRelationVoucherDataPage();
		},
		handleCurrentChange(val) {
			this.voucherpwm.page = val;
			this.getRelationVoucherDataPage();
		},
        dialogHandleSizeChange (val) {
			this.dialogVoucherpwm.limit = val;
			this.getAccountingVoucherUploadData();
		},
		dialogHandleCurrentChange(val) {
			this.dialogVoucherpwm.page = val;
			this.getAccountingVoucherUploadData();
		},
        advanceQueryUploadData() {
			this.getRelationVoucherData();
		},
		companyNameSelectChange(event, item) {  //  手工分组 - 所属实体下拉 change
            this.getRelationVoucherData();
        },
       advanceQueryData(){
            this.getAccountingVoucherUploadData();
       },
        async getRelationVoucherData() {	//	获取记账凭证上传记录数据
			this.voucherpwm.page = 1;
			let pwm = this.voucherpwm;
			pwm.param.companyId = this.manualGroupCompanyName;
			pwm.likeSearch = this.voucherImportSearchName;
			await fetchPost('/relationVoucher/getPageList', pwm).then(res => {
				this.relationArchivesVoucherTableData = res.data.data;
				this.voucherpwm.count = res.data.count;
			}, error => {
				this.$message.error('加载上传信息失败：' + error);
			});
		},
		async getRelationVoucherDataPage() {	//	获取记账凭证上传记录数据
			let pwm = this.voucherpwm;
			pwm.param.companyId = this.manualGroupCompanyName;
			pwm.likeSearch = this.voucherImportSearchName;
			await fetchPost('/relationVoucher/getPageList', pwm).then(res => {
				this.relationArchivesVoucherTableData = res.data.data;
				this.voucherpwm.count = res.data.count;
			}, error => {
				this.$message.error('加载上传信息失败：' + error);
			});
		},
        //打开关联记账凭证页面：
        relationVoucherClick(){
            let idList = [];
			let checkRows = this.$refs.relationArchivesVoucher.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择需要关联的原始凭证信息！');
				return;
			}
			checkRows.forEach(row => {
				idList.push(row.id);	
			});
			let ids = idList.join(",");
			this.voucherHeaderSearchName = "";
            this.viewDialogVisible = true;
            this.getAccountingVoucherUploadData();
        },
        //获取记账凭证列表：
        async getAccountingVoucherUploadData() {
			this.dialogVoucherpwm.limit=10;
			this.dialogVoucherpwm.page = 1;
			let pwm = this.dialogVoucherpwm;
			pwm.param.companyId = this.manualGroupCompanyName;
			pwm.likeSearch = this.dialogVoucherSearchName;
			await fetchPost('/relationVoucher/getVhPageList', pwm).then(res => {
				this.accountingVoucherUploadTableData = res.data.data;
                this.dialogVoucherpwm.count = res.data.count;
			}, error => {
				this.$message.error('加载记账凭证信息失败：' + error);
			});
		},
		//获取记账凭证列表：
        async getAccountingBookVoucherUploadData() {	
			let pwm = this.dialogVoucherpwm;
			pwm.param.companyId = this.manualGroupCompanyName;
			pwm.likeSearch = this.dialogVoucherSearchName;
			await fetchPost('/relationVoucher/getVhBookPageList', pwm).then(res => {
				this.accountingVoucherBookTableData = res.data.data;
                this.dialogVoucherpwm.count = res.data.count;
			}, error => {
				this.$message.error('加载记账凭证信息失败：' + error);
			});
		},
		handleClick(tab, event) {
			this.voucherHeaderSearchName = "";
			if(tab.name == 'first'){
				this.dialogVoucherpwm.page = 1;
            	this.getAccountingVoucherUploadData();
			}else{
				this.dialogVoucherpwm.page = 1;
				this.getAccountingBookVoucherUploadData();
			}
		},
        //关联：
        sureRelation(){
            let checkRows = this.$refs.accountingVoucherUploadTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择需要关联的记账凭证信息！');
				return;
			}else if(checkRows.length > 1 ){
                this.$message.error('最多只能选择一条记账凭证信息');
				return;
            }

            let ohId = checkRows[0].id;
            let ovIdList = [];
			let ovcheck = this.$refs.relationArchivesVoucher.selection;
			ovcheck.forEach(row => {
				ovIdList.push(row.id);	
			});
			let ovIds = ovIdList.join(",");
            let pwm ={"ohId":ohId,"ovIds":ovIds}
            fetchPost('/relationVoucher/relationOv',pwm).then(res => {
                console.log(res)
					if(res.data.success) {
						this.$message.success('关联成功！');
						//	reload table data
                        this.viewDialogVisible = false;
						this.getRelationVoucherData();
					} else {
						this.$message.error('关联失败！' + res.data.msg);
					}
				}, error => {
					this.$message.error('关联失败!' + error);
				});
        },
		//已成册数据关联
		bookRelation(){
			let checkRows = this.$refs.accountingVoucherBookTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择需要关联的记账凭证信息！');
				return;
			}else if(checkRows.length > 1 ){
                this.$message.error('最多只能选择一条记账凭证信息');
				return;
            }
			let ohId = checkRows[0].id;
            let ovIdList = [];
			let ovcheck = this.$refs.relationArchivesVoucher.selection;
			ovcheck.forEach(row => {
				ovIdList.push(row.id);	
			});
			let ovIds = ovIdList.join(",");
            let pwm ={"ohId":ohId,"ovIds":ovIds}
			fetchPost('/relationVoucher/relationBookOv',pwm).then(res => {
				if(res.data.success) {
						this.$message.success('关联成功！');
						//	reload table data
                        this.viewDialogVisible = false;
						this.getRelationVoucherData();
					} else {
						this.$message.error('关联失败！' + res.data.msg);
					}
				}, error => {
					this.$message.error('关联失败!' + error);
			});
		},

		oriVoucherEditClickFun(rowData) {
			console.log(rowData)
			Object.keys(this.oriVoucherEditForm).map(key => (this.oriVoucherEditForm[key] = ''));
			//	人工验证通过的数据不允许凭证编辑
			// if(rowData.fileStatus == '1') {
			// 	this.$message.warning('凭证审核通过的数据，不支持编辑信息！');
			// 	return;
			// }
			//	默认选中凭证类型
			this.voucherTypeImgList = JSON.parse(JSON.stringify(this.originalvoucherTypeList));
			let voucherTypeImgList = this.voucherTypeImgList;
			voucherTypeImgList.forEach(item => {
				if(item.code != rowData.voucherType) {
					item.name = item.name + "-h";
				}
			});
			this.oriVoucherEditForm = JSON.parse(JSON.stringify(rowData));
			this.oriVoucherEditDialogVisible = true;
		},
		voucherTypeImgClickFun(event, index) {	//	凭证类型点击选中/取消选中效果
			//	每次仅一种凭证类型被选中
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			let voucherTypeImgList = this.voucherTypeImgList;
			voucherTypeImgList.forEach(item => {
				if(item.name.lastIndexOf('-h') == -1) {
					item.name = item.name + '-h';
				} else {
					if((item.name.lastIndexOf('-h') + 2) != item.name.length) {
						item.name = item.name + '-h';
					}
				}
			});
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				voucherTypeImgList[index].name = imgName + '-h';
			} else {
				voucherTypeImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}
		},
		saveOriginalVoucherData() {	//	保存原始凭证数据
			let voucherData = this.oriVoucherEditForm;
			let voucherTypeImgList = this.voucherTypeImgList;
			voucherTypeImgList.forEach(item => {
				if(item.name.lastIndexOf('-h') + 2 != item.name.length) {
					voucherData.voucherType = item.code;
				}
			});
			this.$refs['oriVoucherEditForm'].validate((valid) => {
				if (valid) {
					fetchPost('/archival/saveOriginalVoucherData', voucherData).then(res => {
						if(res.data.success) {
							this.$message.success('保存原始凭证信息成功！');
							this.oriVoucherEditDialogVisible = false;
							this.getOriginalVoucherDataByBatchNo(this.batchNo);
						} else {
							this.$message.error('保存原始凭证信息失败：' + res.data.message);
						}
					}, error => {
						this.$message.error('保存原始凭证信息失败：' + error);
					});
				} else {
					console.log("失败")
					return false;
				}
			});
		},

        formatSource(row){
			if(row.source == '1'){
				return "文件上传";
			}else if(row.source == '2'){
                return "接口上传";
            }else if(row.source == '3'){
                return "共享文件夹";
            }else{
                return "邮箱";
            }
        },

		select(selection, row) {
			if (selection.length > 1) {
				let del_row = selection.shift()
				this.$refs.accountingVoucherUploadTable.toggleRowSelection(del_row, false)
			}
			},
		selectAll(selection){
			if (selection.length > 1) {
				selection.length = 1
			}
			}


      }  
    


}


</script>